/**
 * The SOP presentations the editor can show, both manifest-driven. The
 * markdown/TipTap editor is not one of them — it is the fallback for states
 * with no manifest to render, never something the user switches to.
 */
export type TSopViewMode = 'steps' | 'map';

/**
 * Router state that carries "the reader was on the map" from one page to the
 * next, so starting a run from the map lands on the new run's map rather than
 * on its document.
 */
export type TAopViewLocationState = { aopView?: TSopViewMode };

/** Navigation state asking the next page to open on its map. */
export const AOP_MAP_LOCATION_STATE: TAopViewLocationState = { aopView: 'map' };

/**
 * Whether the page was reached from a map, and so should open on its own.
 *
 * @param state - `location.state`, which any page may have set to anything
 * @returns True when the previous page asked for the map
 */
export function isAopMapRequested(state: unknown): boolean {
  return (
    typeof state === 'object' &&
    state !== null &&
    (state as TAopViewLocationState).aopView === 'map'
  );
}
